<div class="circle" #el>
    <canvas class="cvsBg" #cvsBg></canvas>
    <canvas class="cvs" #cvs></canvas>
</div>
